module.exports = __webpack_public_path__ + "img/person.437a568c.svg";